import { get } from 'lodash';
import { StyleSheet, Platform } from 'react-native';
import { checkFont, checkStyles } from '../func';

const createStyles = ({
  attributes,
  isError,
}: {
  attributes: any;
  isError: boolean;
}) => {
  const { width, opacity } = attributes;

  return StyleSheet.create({
    wrapperInput: {
      padding: 10,
      borderRadius: 5,
      borderColor: '#BDBDBD',
      borderWidth: 1,
      minHeight: 40,
    },
    title: {
      marginBottom: 6,
      ...checkStyles(get(attributes, 'title.styles')),
    },

    text: {
      paddingVertical: 8,
      color: isError ? '#ff0000' : '#008000',
    },

    submitButton: {
      justifyContent: 'center',
      marginTop: 20,
      minHeight: 44,
      backgroundColor: get(attributes, 'submitButton.styles.backgroundColor'),
      borderColor: get(attributes, 'submitButton.styles.backgroundColor'),
      borderRadius: get(attributes, 'submitButton.styles.borderRadius'),
    },
    connectButton: {
      justifyContent: 'center',
      marginTop: 20,
      minHeight: 44,
      backgroundColor: get(attributes, 'connectButton.styles.backgroundColor'),
      borderColor: get(attributes, 'connectButton.styles.backgroundColor'),
      borderRadius: get(attributes, 'connectButton.styles.borderRadius'),
    },
    disconnectButton: {
      justifyContent: 'center',
      marginTop: 20,
      minHeight: 44,
      backgroundColor: get(
        attributes,
        'disconnectButton.styles.backgroundColor'
      ),
      borderColor: get(attributes, 'disconnectButton.styles.backgroundColor'),
      borderRadius: get(attributes, 'disconnectButton.styles.borderRadius'),
    },

    btnMobile: {
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: 20,
      height: 44,
      lineHeight: 44,
    },

    labelStyleMobile: {
      marginTop: 0,
      marginLeft: 0,
    },
    submitButtonLabelStyle: {
      ...checkStyles(get(attributes, 'submitButton.styles')),
    },
    connectLabelStyle: {
      ...checkStyles(get(attributes, 'connectButton.styles')),
    },
    disconnectLabelStyle: {
      ...checkStyles(get(attributes, 'disconnectButton.styles')),
    },
    // style on mobile
    container: {
      width,
      opacity,
    },
  });
};

export default createStyles;
